<template>
  <li class="li">
    <div class="li-cover" @click="open">
      <img v-if="item.cover" class="li-img" :src="coverUrl" :alt="item.name" />
      <div v-else class="li-img li-placeholder">{{ item.name }}</div>
      <span class="badge" :class="badge.className" :title="badge.tip">
        <i class="badge-dot"></i>{{ badge.text }}
      </span>
    </div>
    <div class="li-description">
      <div class="title" :title="item.name">{{ item.name }}</div>
      <div class="preview" @click="open">预览</div>
    </div>
  </li>
</template>

<script>
import { TipsPop } from '@/utils/tool';

export default {
  name: 'ProjectCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    // healthStatus：1 在线，0 离线，null 表示定时任务尚未探测过
    badge() {
      if (this.item.healthStatus === 1) {
        return { text: '在线', className: 'badge-on', tip: '服务可正常访问' };
      }
      if (this.item.healthStatus === 0) {
        return { text: '离线', className: 'badge-off', tip: '最近一次健康探测失败' };
      }
      return { text: '未探测', className: 'badge-unknown', tip: '尚未进行健康探测' };
    },
    coverUrl() {
      const url = this.item.cover;
      if (!url) {
        return '';
      }
      // 后端存的可能是完整地址，也可能是老 GIS 服务上的相对路径
      if (/^(https?:)?\/\//.test(url)) {
        return url;
      }
      return `${process.env.VUE_APP_CASE_ASSET_URL || ''}${url}`;
    }
  },
  methods: {
    open() {
      if (!this.item.webUrl) {
        TipsPop({
          message: '未配置系统地址，无法预览',
          type: 'error'
        });
        return;
      }
      window.open(this.item.webUrl, '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
.li {
  overflow: hidden;
  border: 1px solid #3a4659;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02), 0 4px 8px rgba(0, 0, 0, 0.02);
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.li:hover {
  outline: 1px solid #2681ff;
  box-shadow: 0 8px 20px #000;
  transform: translateY(-1px);
}

.li-cover {
  position: relative;
}

.li-img {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
  cursor: pointer;
}

.li-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  color: rgba(255, 255, 255, 0.42);
  font-size: 13px;
  text-align: center;
  background: #16202a;
}

.badge {
  position: absolute;
  top: 8px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 9px;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  white-space: nowrap;
  border-radius: 11px;
  background: rgba(9, 14, 20, 0.62);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  pointer-events: none;
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.badge-on {
  color: #4ade80;
  border-color: rgba(74, 222, 128, 0.42);
}

.badge-on .badge-dot {
  box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.65);
  animation: badgePulse 1.8s ease-out infinite;
}

.badge-off {
  color: #f87171;
  border-color: rgba(248, 113, 113, 0.42);
}

.badge-unknown {
  color: rgba(255, 255, 255, 0.62);
}

.li-description {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 38px;
  padding: 0 10px;
  background: #1d262e;
}

.title {
  flex: 1;
  overflow: hidden;
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.preview {
  color: #20d6e9;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

@keyframes badgePulse {
  70% {
    box-shadow: 0 0 0 6px rgba(74, 222, 128, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(74, 222, 128, 0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .badge-on .badge-dot {
    animation: none;
  }
}
</style>
